/**
 * 对股票名称进行掩码处理
 *
 * @param name 股票名称
 * @param enabled 是否启用掩码
 * @returns 掩码后的名称
 *
 * @example
 * maskStockName('贵州茅台', true) // '贵***'
 * maskStockName('*ST康美', true) // '*S***'
 * maskStockName('中', true) // '中' (单字不掩码)
 * maskStockName('贵州茅台', false) // '贵州茅台' (未启用掩码)
 */
export function maskStockName(name: string, enabled: boolean): string {
  if (!name || !enabled) return name
  if (name.length <= 1) return name
  
  // 普通股票：保留首字符 + ***
  return name.charAt(0) + '***'
}

/**
 * 对股票代码进行掩码处理
 *
 * @param code 股票代码
 * @param enabled 是否启用掩码
 * @returns 掩码后的代码
 *
 * @example
 * maskStockCode('300100', true) // '******'
 * maskStockCode('600519', true) // '******'
 * maskStockCode('300100', false) // '300100' (未启用掩码)
 */
export function maskStockCode(code: string, enabled: boolean): string {
  if (!code || !enabled) return code
  return '*'.repeat(code.length)
}
